import React from 'react'
import { isEmpty, isObject, map } from 'lodash'

import { TreeSelectNodeTitle } from '../components/sections'

const renderTreeSelectDropdownItemCurationDisabledColor = options =>
  map(options, item => {
    const title = isObject(item.title) ? item.title?.props?.title : item.title

    return {
      ...item,
      title: (
        <TreeSelectNodeTitle
          title={title}
          isMuted={item.isCurationEnabled === false}
        />
      ),
      ...(!isEmpty(item.children) && {
        children: renderTreeSelectDropdownItemCurationDisabledColor(
          item.children,
        ),
      }),
    }
  })

const handleTreeSelectDropdownItemCurationDisabledColor = origin => ({
  ...origin,
  props: {
    ...origin.props,
    options: renderTreeSelectDropdownItemCurationDisabledColor(
      origin.props.options,
    ),
  },
})

export default handleTreeSelectDropdownItemCurationDisabledColor
